/* eslint-disable */

import axios from 'axios'
import EnvService from '@/services/env.service'
import qs from 'qs'
import store from '@/store'

axios.defaults.baseURL = EnvService.apiBaseURL

axios.interceptors.request.use(function(config) {

    if (store.state.auth.accessToken) {
        config.headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`;
    }

    if (config.params && config.params._auth && config.params._auth === true) {
        config._auth = true
        delete config.params._auth
    }

    config.headers['Content-Type'] = 'application/json';

    return config

}, function(error) {
    return Promise.reject(error)
})


axios.interceptors.response.use(function(response) {
    return response
}, function(error) {

    let isAuth = error.config && !!error.config._auth && error.config._auth === true

    // https://github.com/axios/axios/issues/934
    if (error.config && !isAuth && error.response && error.response.status === 401) {

        return ApiService.refreshToken(store.state.auth.refreshToken)
            .then(data => {
                store.commit('auth/setAccessToken', data.accessToken)
                store.commit('auth/setRefreshToken', data.refreshToken)
                return axios.request(error.config)
            })
            .catch(error => {
                if (error.response.status === 401) {
                    store.dispatch('auth/logout')
                    location.reload()
                }
                return Promise.reject(error)
            })
    }

    return Promise.reject(error)
})

function convertErrors(errors) {
    let convertedErrors = {}

    if (Array.isArray(errors)) {
        errors.forEach(function(element) {
            if (element.field && element.message) {
                if (!convertedErrors[element.field]) {
                    convertedErrors[element.field] = []
                }
                convertedErrors[element.field].push(element.message)
            }
        })
    }

    return convertedErrors
}

function mapOptions(options) {
    let convertedOptions = {
        page: options && options.page ? options.page : null,
        'per-page': options && options.itemsPerPage ? options.itemsPerPage : null,
    }

    if (options && options.sortBy[0]) {
        convertedOptions.sort = (options && options.sortDesc[0] ? '-' : '') + options.sortBy[0]
    }

    return convertedOptions
}



const ApiService = {

    login(credentials) {
        return axios.post('/users/login', credentials, {
            params: { _auth: true },
        }).then(response => {
            return Promise.resolve(response.data)
        })
    },

    refreshToken(refreshToken) {
        return axios.get('/users/refresh', {
            params: { refreshToken, _auth: true },
        }).then(response => {
            return Promise.resolve(response.data)
        })
    },

    // defaults
    update(path, data, config = {}) {
        return axios.put(path, data, config).then(response => {
            return Promise.resolve(response.data)
        }).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },

    create(path, data, config = {}) {
        return axios.post(path, data, config).then(response => {
            return Promise.resolve(response.data)
        }).catch(error => {
            return Promise.reject(convertErrors(error.response.data))
        })
    },

    index(path, options = null, config = {}) {
        config.params = Object.assign({}, (config.params || {}), mapOptions(options))
        config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' })

        return axios.get(path, config).then(response => {
            if (options === null) {
                return Promise.resolve(response.data)
            }

            let total = Number(response.headers['x-pagination-total-count'] || 0)
            return Promise.resolve({ items: response.data, total })
        })
    },

    view(path, config = {}) {
        return axios.get(path, config).then(response => {
            return Promise.resolve(response.data)
        })
    },

    delete(path, config = {}) {
        return axios.delete(path, config).then(response => {
            return Promise.resolve(response.data)
        })
    },

    post(path, data, config = {}) {
        return axios.post(path, data, config).then(response => {
            return Promise.resolve(response.data)
        })
    },

    get(path, config = {}) {
        return axios.get(path, config).then(response => {
            return Promise.resolve(response.data)
        })
    },


}

export default ApiService
